/* eslint-disable camelcase */
import ip from 'icepick';
import {
  APPLICATION_CAR_DATA,
  GET_META_DATA,
  LOAN_DETAIL,
  LOAN_FORM_DETAILS,
  LOAN_REQUESTED_AMOUNT,
  LOAN_TYPE,
  MORE_PERSONAL_INFO,
  NEW_FLOW_ACTIVE,
  PRICE_FIELD,
  USED_CAR_NEW_CAR,
  VEHICLE_DATA,
  VEHICLE_DETAIL_FORM,
} from './type';
import { ReducerType } from '../types/reducer';

const initialState: ReducerType = ip.freeze({
  metaData: {},
  vehicleDetailForm: {},
  morePersonalDetail: {},
  loanDetail: {},
  selectedVehicleData: {},
  applicationCarData: null,
  loanType: 'new_car',
  carDetailForm: {},
  showPriceField: false,
  usedCarNewCarForm: {},
  loanFormDetails: {
    loanAmount: 1000000,
    tenure: 1,
    roi: 9.5,
    emi: 0,
  },
  loanRequestedAmount: 0,
  newFlowActive: false
});

export function refinanceReducer(state = initialState, action) {
  switch (action.type) {
    case GET_META_DATA: {
      state = ip.setIn(state, ['metaData'], action.payload);
      return state;
    }
    case VEHICLE_DETAIL_FORM: {
      state = ip.setIn(state, ['vehicleDetailForm'], action.payload);
      return state;
    }
    case MORE_PERSONAL_INFO: {
      state = ip.setIn(state, ['morePersonalDetail'], action.payload);
      return state;
    }
    case LOAN_DETAIL: {
      state = ip.setIn(state, ['loanDetail'], action.payload);
      return state;
    }
    case VEHICLE_DATA: {
      state = ip.setIn(state, ['selectedVehicleData'], action.payload);
      return state;
    }
    case APPLICATION_CAR_DATA: {
      state = ip.setIn(state, ['applicationCarData'], action.payload);
      return state;
    }
    case LOAN_TYPE: {
      state = ip.setIn(state, ['loanType'], action.payload);
      return state;
    }
    case PRICE_FIELD: {
      state = ip.setIn(state, ['showPriceField'], action.payload);
      return state;
    }
    case USED_CAR_NEW_CAR: {
      state = ip.setIn(state, ['usedCarNewCarForm'], action.payload);
      return state;
    }
    case LOAN_FORM_DETAILS: {
      state = ip.setIn(state, ['loanFormDetails'], action.payload);
      return state;
    }
    case LOAN_REQUESTED_AMOUNT: {
      state = ip.setIn(state, ['loanRequestedAmount'], action.payload);
      return state;
    }
    case NEW_FLOW_ACTIVE: {
      state = ip.setIn(state, ['newFlowActive'], action.payload);
      return state;
    }
    default:
      return state;
  }
}

export default refinanceReducer;
